export default "__VITE_ASSET__Dod2Ob7f__"